
import React, { useRef, useState } from 'react';
import { PageHeader } from '../components/layout/Header';
import SearchInput from '../components/ui/SearchInput';
import { Button } from '../components/ui/Button';
import WhatsappConnections from '../features/connections/channels/WhatsappConnections';
import WhatsappCoexistenceConnections from '../features/connections/channels/WhatsappCoexistenceConnections';
import InstagramConnections from '../features/connections/channels/InstagramConnections';

const ConnectionsPage: React.FC = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const addConnectionRef = useRef<(() => void) | null>(null);

    return (
        <div className="flex h-full flex-col">
            <PageHeader
                title="Canais de Atendimento"
                subtitle="Gerencie suas conexões com plataformas de mensagens."
                className="mb-0 gap-s3 md:mb-6 md:gap-3"
                titleClassName="text-lg md:text-xl"
                actionClassName="w-full md:w-auto"
                hideBackButton
                action={
                    <>
                        <div className="flex w-full flex-col gap-s3 md:hidden">
                            <SearchInput
                                value={searchTerm}
                                onChange={setSearchTerm}
                                placeholder="Pesquisar conexões..."
                                className="min-h-11 w-full"
                            />
                            <Button
                                type="button"
                                onClick={() => addConnectionRef.current?.()}
                                className="min-h-11 w-full touch-manipulation"
                            >
                                Nova Conexão
                            </Button>
                        </div>
                        <div className="hidden md:flex md:items-center md:gap-2.5">
                            <div className="w-[250px] shrink-0">
                                <SearchInput
                                    value={searchTerm}
                                    onChange={setSearchTerm}
                                    placeholder="Pesquisar conexões..."
                                    className="h-[36px]"
                                />
                            </div>
                            <Button type="button" onClick={() => addConnectionRef.current?.()}>
                                Nova Conexão
                            </Button>
                        </div>
                    </>
                }
            />
            <section aria-label="Lista de canais" className="min-h-0 flex-1 pt-s3 md:pt-0 space-y-6">
                <WhatsappConnections
                    searchTerm={searchTerm}
                    onSearchChange={setSearchTerm}
                    onAddConnectionRef={(fn) => {
                        addConnectionRef.current = fn;
                    }}
                />
                <WhatsappCoexistenceConnections />
                <InstagramConnections />
            </section>
        </div>
    );
};

export default ConnectionsPage;
